import Vue from "vue";
import VueRouter from "vue-router";
import index from "../views/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    // 首页
    path: "/",
    name: "index",
    component: index,
  },
  {
    // 提交等待页
    path: "/wait",
    name: "wait",
    component: () => import("../views/wait.vue"),
  },
  // {
  //   // textList 文案大全
  //   path: "/textList",
  //   name: "textList",
  //   component: () => import("../views/textList.vue"),
  // },
  // {
  //   // text
  //   path: "/text",
  //   name: "text",
  //   component: () => import("../views/text.vue"),
  // },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }; // 切换路由时回到顶部
  },
});

export default router;
